import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const ActivityLayout = () => {
   const navList = useNav();
  let {activityBottomNav, topActivityNav} = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={activityBottomNav} topTabs={topActivityNav} />
      <Outlet />
    </div>
  )
}

export default ActivityLayout;